import PriceResumeCard from './PriceResumeCard';

export default PriceResumeCard;
